export const modalStyle = {
	wrapper: {
		'& .MuiDialog-scrollPaper': {
			background: 'var(--default-white)',
		},
	},

	modalIcon: {
		marginBottom: '32px',
		textAlign: 'center',

		'& svg': {
			width: '60px',
			height: '60px',
		},
	},

	modalIconClose: {
		position: 'absolute',
		right: '8px',
		top: '8px',
		zIndex: 1,
	},

	modalContent: {
		display: 'flex',
		justifyContent: 'center',
		// justifyContent: 'flex-start',
		flexDirection: 'column',
		alignItems: 'center',
		padding: 'unset',
		overflow: 'hidden',
		width: '100%',
	},

	modalContentTitle: {
		textTransform: 'capitalize',
		textAlign: 'center',
		fontSize: '24px',
		padding: '0',
		whiteSpace: 'nowrap',
	},

	modalContentText: {
		paddingTop: '8px',
		textAlign: 'center',
		fontSize: '16px',
		lineHeight: '24px',
	},

	actions: {
		display: 'flex',
		justifyContent: 'space-evenly',
		gap: '24px',
		margin: '0 auto',
		marginTop: '32px',

		'@media (max-width: 639.98px)': {
			flexDirection: 'column',
			gap: '12px',
		},
	},
	actionsBottom: {
		display: 'flex',
		justifyContent: 'space-evenly',
		gap: '24px',
		marginTop: 'auto',
	},

	buttonClose: {
		height: '44px',
	},

	buttonSave: {
		height: '44px',
		width: '100%',
		lineHeight: '16px',
		paddingX: '8px',
	},

	contentWrapper: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
};
